module.exports = __webpack_public_path__ + "img/footerIcon.e9a80dae.png";